
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { OfficeFields } from "./document/fields/OfficeFields"
import { RequestFields } from "./document/fields/RequestFields"
import { SpeechFields } from "./document/fields/SpeechFields"
import { MemorandumFields } from "./document/fields/MemorandumFields"

interface DocumentFormFieldsProps {
  type: "oficio" | "requerimento" | "discurso" | "memorando"
  formData: {
    subject?: string
    content: string
    recipient?: string
    officeType?: string
    requestType?: string
    eventType?: string
    targetAudience?: string
    speechObjective?: string
    memorandumType?: string
  }
  onChange: (field: string, value: string) => void
}

export function DocumentFormFields({ type, formData, onChange }: DocumentFormFieldsProps) {
  return (
    <div className="space-y-4">
      {type === "memorando" && (
        <MemorandumFields
          recipient={formData.recipient || ""}
          memorandumType={formData.memorandumType}
          onChange={onChange}
        />
      )}

      {type === "oficio" && (
        <OfficeFields
          recipient={formData.recipient || ""}
          officeType={formData.officeType}
          onChange={onChange}
        />
      )}

      {type === "requerimento" && (
        <RequestFields
          requestType={formData.requestType}
          onChange={onChange}
        />
      )}

      {type === "discurso" && (
        <SpeechFields
          eventType={formData.eventType}
          targetAudience={formData.targetAudience}
          speechObjective={formData.speechObjective}
          onChange={onChange}
        />
      )}

      <div className="space-y-2">
        <Label htmlFor="content" className="text-sm font-medium text-gray-700 after:content-['*'] after:ml-0.5 after:text-red-500">
          Conteúdo
        </Label>
        <Textarea
          id="content"
          value={formData.content}
          onChange={(e) => onChange("content", e.target.value)}
          className="min-h-[150px] border-gray-200 focus:ring-primary/20 resize-none"
          placeholder="Digite o conteúdo do documento..."
          required
        />
      </div>
    </div>
  )
}
